import { render, staticRenderFns } from "./NewTrader.vue?vue&type=template&id=167ae670&"
import script from "./NewTrader.vue?vue&type=script&lang=js&"
export * from "./NewTrader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports